export const toggleDetailsView = () => {
    const arrow = document.querySelector(".details .arrow i");
    arrow.classList.toggle("reverse");
    const details = document.querySelector(".details");
        details.classList.toggle("active");
};

export const toggleMenuView = () => {
    const navMenu = document.getElementsByTagName("nav")[0];
    const arrow = document.querySelector(".arrow i");
        arrow.classList.toggle("reverse");
        navMenu.classList.toggle("active");
};